import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class NavigationStateService {
  private errorMessage: string | null = null;

  setErrorMessage(message: string) {
    this.errorMessage = message;
  }

  getErrorMessage(): string | null {
    return this.errorMessage;
  }

  clear() {
    this.errorMessage = null;
  }
}